import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath } from '../../content/siteContentUtils';

const fallbackDocumentsText = [
    {
        title: 'Ürün Kataloğu',
        description: 'Kapı model ve teknik bilgilerini içeren güncel katalog dokümanı.',
    },
    {
        title: 'Kalite Sertifikası',
        description: 'Üretim kalite standartlarımızı gösteren belge.',
    },
    {
        title: 'Garanti Koşulları',
        description: 'Ürün garanti kapsamı ve kullanım şartlarını içeren doküman.',
    },
];

const fallbackDocumentsConfig = [
    { iconClass: 'flaticon-certificate', fileUrl: '' },
    { iconClass: 'flaticon-certificate', fileUrl: '' },
    { iconClass: 'flaticon-certificate', fileUrl: '' },
];

class DocumentsSection extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const section = t?.pages?.about?.documents || {};
        const textItems = Array.isArray(section.items) ? section.items : [];
        const mediaItems = getByPath(content, 'media.pages.aboutDocuments', []);
        const catalogPdfUrl = (getByPath(content, 'media.catalogPdfUrl', '') || '').trim();

        const safeMediaItems = Array.isArray(mediaItems) ? mediaItems : [];
        const configuredLength = Math.max(textItems.length, safeMediaItems.length);
        const useFallback = configuredLength === 0;
        const itemCount = useFallback ? fallbackDocumentsText.length : configuredLength;

        const items = Array.from({ length: itemCount }).map((_, index) => {
            const fallback = fallbackDocumentsText[index] || {
                title: `Belge ${index + 1}`,
                description: '',
            };
            const mediaItem = safeMediaItems[index] || {};
            const fileUrl = (mediaItem.fileUrl || '').trim();

            return {
                ...fallback,
                ...(fallbackDocumentsConfig[index] || { iconClass: 'flaticon-certificate', fileUrl: '' }),
                ...(textItems[index] || {}),
                ...mediaItem,
                fileUrl: fileUrl || (index === 0 ? catalogPdfUrl : ''),
            };
        });

        const title = section.title || 'Belgelerimiz';
        const description = section.description || 'Kurumsal ve teknik dokümanlarımıza bu alandan erişebilirsiniz.';
        const openLabel = section.openLabel || 'Belgeyi Aç';
        const missingLabel = section.missingLabel || 'Belge Yakında';

        return (
            <div className="section-full mobile-page-padding p-t80 p-b50 bg-white">
                <div className="container">
                    <div className="section-head">
                        <div className="sx-separator-outer separator-left">
                            <div className="sx-separator bg-white bg-moving bg-repeat-x">
                                <h3 className="sep-line-one">{title}</h3>
                            </div>
                        </div>
                        <p>{description}</p>
                    </div>
                    <div className="row">
                        {items.map((item, index) => {
                            const hasFile = Boolean((item.fileUrl || '').trim());
                            return (
                                <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={`about-document-${index}`}>
                                    <div className="sx-icon-box-wraper p-a30 bg-gray h-100">
                                        <div className="icon-xl m-b20">
                                            <span className="icon-cell text-primary">
                                                <i className={item.iconClass || 'flaticon-certificate'} />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="sx-tilte">{item.title}</h4>
                                            <p>{item.description}</p>
                                            <a
                                                href={hasFile ? item.fileUrl : '#'}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="site-button-link"
                                                onClick={(event) => {
                                                    if (!hasFile) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                style={{ opacity: hasFile ? 1 : 0.55 }}
                                            >
                                                {hasFile ? openLabel : missingLabel}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentsSection;
